import { useEffect, useMemo, useRef } from 'react';
import { useParams } from 'react-router-dom';
import useAppModal from 'hooks/useAppModal';
import useAppSelector from 'hooks/useAppSelector';
import usePropertySettingsInitData from '../usePropertySettingsInitData';
import { seasonalRuleModalId } from './modals/seasonalRuleAddEditModal/SeasonalRuleAddEditModal.constants';
import useSeasonalRuleModal from './modals/seasonalRuleAddEditModal/useSeasonalRuleModal';

const PropertySettingsSeasonalityTabModal = () => {
  const hasInit = useRef(false);
  const { seasonalRuleUid } = useParams();
  const activeModals = useAppSelector((state) => state.modal.activeModals);
  const { closeModal } = useAppModal();
  const { openAddSeasonalRuleModal, openEditSeasonalRuleModal } =
    useSeasonalRuleModal();
  const { property } = usePropertySettingsInitData();
  const currentProperty = useMemo(
    () =>
      property?.uid && property?.name
        ? { uid: property.uid, name: property.name }
        : undefined,
    [property?.uid, property?.name],
  );

  useEffect(() => {
    if (
      seasonalRuleUid &&
      !activeModals[seasonalRuleModalId] &&
      !hasInit.current
    ) {
      if (seasonalRuleUid === 'add') {
        openAddSeasonalRuleModal({ currentProperty });
      } else {
        openEditSeasonalRuleModal({ seasonalRuleUid, currentProperty });
      }
      hasInit.current = true;
    }
  }, [
    activeModals,
    seasonalRuleUid,
    openAddSeasonalRuleModal,
    openEditSeasonalRuleModal,
    currentProperty,
  ]);

  useEffect(() => {
    return () => {
      if (hasInit.current) {
        closeModal(seasonalRuleModalId);
        hasInit.current = false;
      }
    };
  }, [closeModal]);

  return null;
};

export default PropertySettingsSeasonalityTabModal;
